<section class="home-video-vidhema-section" style="position: relative;" #targetSection [ngStyle]="{'transform': 'scale(' + scale + ')'}">
    <div class="videohomebg">
      <img src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/bannerimage.jpg?alt=media&token=87c396ac-ff52-4bc1-9ac1-fa423e1a0e34" alt="Home Image Banner">
    </div>
    <div class="container-fluid" style="position: absolute;top:0;bottom:0;left: 0;right: 0;margin: auto;background:rgba(0,0,0,0.38);">
        <div class="bg-img row">
            <div class="col-md-12 cardcssafter">
            <mat-card class="card">
                <div class="content header-text">
                <h1 class="main-text">Innovating Together, Always</h1>
                <p _ngcontent-serverapp-c100=""> Driving Innovation with Collaborative Solutions for a Better Tomorrow</p>
                <a routerLink="/getaquote.html" href="">Request a Quote</a>
            </div>
            </mat-card>
            </div>
        </div>
    </div> 
</section>